import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from '@app/services/dialog.service';
import { Store } from '@ngxs/store';

@Component({
    selector: 'app-video',
    templateUrl: './video.component.html',
    styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

    @Input() data!: any;
    url: string = '';

    constructor(
        private readonly store: Store,
        private readonly dialog: DialogService
    ) {}

    ngOnInit(): void {}

    async download(): Promise<void> {
        try {
            const response = await fetch(this.data.presignedUrl);

            if (!response.ok) {
                throw new Error(`Download failed: ${response.status}`);
            }

            const link = document.createElement('a');
            link.href = this.data.presignedUrl;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Download failed:', error);
        }
    }

    fullscreen(video: HTMLVideoElement): void {
        if (video.requestFullscreen) {
            video.requestFullscreen();
        }
    }
}